import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { assignApplicationByIdFailed, assignApplicationByIdSuccessful } from '../actions';

export default function* assignApplicationById(action) {
  try {
    // const url = `${BACKEND_URL}/resources/applications/${action.payload}`;
    const url = `${BACKEND_URL}/resources/applications/${action.payload}/assign`;
    const dataResponse = yield makeRequest(url, {}, action, 'POST', true);
    // const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(assignApplicationByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      const data = yield dataResponse.json();
      yield put(assignApplicationByIdFailed());
      yield call(rejectActionPromise(action, { ...data, status: dataResponse.status }));
    }
  } catch (e) {
    yield put(assignApplicationByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
